import EVENTS from '@shared/events';
import { BaseController } from '@shared/basecontroller.controller';

class WithdrawalController extends BaseController {
  constructor(AppService, CustomerApiService, PageService, WithdrawalStore, $timeout) {
    'ngInject';

    super(AppService);

    this.CustomerApiService = CustomerApiService;
    this.PageService = PageService;
    this.WithdrawalStore = WithdrawalStore;
    this.hasAvailablePaymentOption = false;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.session = this.getSession();
    this.removeSettingsHighlight();
    this.checkStatus();
    this.detailsSubscription = this.WithdrawalStore.getWithdrawDetails().subscribe((details) => {
      this.details = details;
      this.paymentOptions = this.details.paymentOptions;
      this.PaymentOptionsViewDetails = details.paymentOptionsViewDetails;
      if (details.paymentOptions.length) {
        this.hasAvailablePaymentOption = true;
        this.onPaymentOptionsSelected(this.paymentOptions[0]);
      }
    });

    this.addListener(EVENTS.BET_PROCESSED, event => this.refreshCustomerProducts());
    this.addListener(EVENTS.TRANSACTION_PROCESSED, event => this.refreshCustomerProducts());
  }

  $onDestroy() {
    super.$onDestroy();
    this.detailsSubscription.unsubscribe();
  }

  onPaymentOptionsSelected(paymentOption) {

    this.selectedPaymentOption = paymentOption;

    // // highlight active tab.
    angular.forEach(this.paymentOptions, value => value.activeTab = false);
    paymentOption.activeTab = true;

    // // update view details
    this.PaymentOptionsViewDetails.updateView(paymentOption);
  }

  isEcopayz() {
    return this.selectedPaymentOption.type === 'ECOPAYZ';
  }

  isSkrill() {
    return this.selectedPaymentOption.type === 'SKRILL';
  }

  isNeteller() {
    return this.selectedPaymentOption.type === 'NETELLER';
  }

  isBitcoin() {
    return this.selectedPaymentOption.type === 'BITCOIN';
  }

  isBank() {
    return this.selectedPaymentOption.type === 'BANK';
  }

  refreshCustomerProducts() {
    this.broadcast('reload.customer-products');
  }

  onSuccessfulSubmission() {
    this.PageService.showModal('successModal');
  }

  finishTransaction() {
    this.PageService.goto('overview');
  }

  onCloseModal() {
    $('#errorModal').modal('hide');
  }

  checkStatus() {
    this.WithdrawalStore.getStatus()
    .then((response) => {
      this.setSessionItem('verifiedAt', response.verified_at);
      
      this.session = this.getSession(); // Refresh session if verifiedAt somehow changed.
      if (!this.session.isVerified() || !this.session.hasSetupTransactionAuthentication()) {
        let checkBitcoin = response.details.enabledPaymentOption.filter(function(item) {
          return item.code === 'BITCOIN';
        });

        if ((response.currency.code !== 'BTC') || (checkBitcoin.length <= 0)) {
          $('#modal-withdraw').show();
        }
      }
    });
  }

  removeSettingsHighlight() {
    this.$timeout(() => {
      $('#settings').removeClass('subdrop');
    }, 100);
  }
}

export default WithdrawalController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/withdrawal/withdrawal.controller.js